import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCloseQuote2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"close-quote-2, blockquote"} maskId="square-outlined-radius-0-stroke-1-IconCloseQuote2"><path d="M10.5 4.5H2.5V12.5L6.5 12.5V19.5C6.5 19.5 10.5 17.8929 10.5 13.0714V4.5Z" stroke="currentColor"/><path d="M21.5 4.5H13.5V12.5L17.5 12.5V19.5C17.5 19.5 21.5 17.8929 21.5 13.0714V4.5Z" stroke="currentColor"/></CentralIconBase>;
}));

export default IconCloseQuote2;
